import React from 'react';
import { ModuleBase } from '@/components';

const NoHeroModule = ({ data }) => {
  return <ModuleBase data={data} className="h-20 bg-white" />;
};

export default NoHeroModule;
